import React from 'react';
import PropTypes from 'prop-types';
import HomePage from '@components/home-page';

const EnglishHomePage = ({ location }) => <HomePage location={location} language="en" />;

EnglishHomePage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default EnglishHomePage;
